import singleselect from './SingleSelect.vue'
const SingleSelect = {
	install: function(Vue) {
		Vue.component('SingleSelect', singleselect)
	}
}
export default SingleSelect
